module.exports = ".back_img{\n    background-color: #00efff;\n    background: linear-gradient(rgb(173, 165, 165),#00e6e6);\n\n}"